import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import UploadFilesView from '../add-edit-product/ViewUploadedFiles/UploadFilesView';
import {  toggleEditDisplayNameModal,
          renameBrochureName,
          resetFileAttachmentData,
          deleteBrochure,
          resetBrochureFileHistory,
          toggleFileProgressBar
        } from '../../actions/products';
import ImagePreview from '../add-edit-product/image-zoom/ImagePreview';
import DisputeImages from '../order/order-return/raise-return-claim/disputeImagesFlow/DisputeImages';
import OrderAttachments from '../add-edit-product/image-zoom/OrderAttachments';
import DeleteModal from './DeleteModal';
import BrochureUploadModal from './BrochureUploadModal';
import './brochure-listing.scss';
import { checkLoggedIn } from '../../utills';

const BrochureListing = props => {
    const {
        brochureAttachment,
        uploadedFileModalData,
        session,
        isContractor
    } = props;
    const imagePreviewRef = useRef(null);
    const [previewImageList, updateImageArr] = useState([]);
    const [showDeleteModal,toggleDeleteModal] = useState({ show: false , data: null });
    const [brochureModalData, setBrochureModalData] = useState({ show: false, files: [] });
    const history = useHistory();

    const getFilteredImages = () => {
        return brochureAttachment.fileAttachments.map((cur, index) => {
            return {
                previewUrl: cur.url,
                fileId: cur.fileId || cur.id,
                key: cur.key || cur.id,
                text: brochureAttachment.fileAttachments.length == 1 ? '' : <div className="preview-text" style={{
                    "position": `${props.isMobile ? "absolute" : "fixed"}`,
                    "left": "50%",
                    "transform": "translateX(-50%)",
                    "height": "44px",
                    "padding": "10px 20px 10px 20px",
                    "background": "rgba(0,0,0,0.75)",
                    "border-radius": "6px",
                    "display": "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    "font-size": "14px",
                    "top": "20px"
                }}><div>Image&nbsp;</div><div className='prescription-count'>{(index + 1)}</div><span>&nbsp;/&nbsp;</span><div className='prescription-count'>list length</div></div>,
                type: cur.extension
            }
        });
    }
    useEffect(() => {
        if(brochureAttachment.fileAttachments?.length)
            updateImageArr(getFilteredImages);
    }, [brochureAttachment.fileAttachments]);

    const saveDisplayName = (inputObj) => {
        let fileName = inputObj[0].input.value;
        console.log(inputObj)
        props.renameBrochureName({fileName, fileId :props.currentFile.fileId});
    }

    const handleFileChange = async (e) => {
        const { target : { files } } = e;
        const { brochureFileHandling } = await import('./brochurelisting.utils');
        try {
            const uploadedFiles = await brochureFileHandling(files, history, 'brochure');
            if (props.session?.newProfile != 3 && uploadedFiles && uploadedFiles.length > 0) {
                setBrochureModalData({ show: true, files: uploadedFiles });
            }
        } catch(err){
            console.error(err);
        }
    }

    const handleDelete = () => {
        if(showDeleteModal.data){
            props.deleteBrochure(showDeleteModal.data);
            setTimeout(() => toggleDeleteModal({ show: false , data: null }), 200);
            props.resetBrochureFileHistory();
            setTimeout(() => props.toggleFileProgressBar({ show: false }));
        }
    }

    const onDelete = (payload) => {
        checkLoggedIn({ history , cb: () => {
            toggleDeleteModal({ show: true , data: payload });
        }})
    }

    const validateInput = (inputObj, validateCB) => {
        let inputField = inputObj[0];
             if(!inputField.input.value){
                  validateCB({isError: true, errorMsg: 'Please Enter Display Name', inputField});
             }else{
                  validateCB({isError: false, errorMsg: ''});
             }
       }


    const progressProps = {
		uploadedCount: brochureAttachment.uploadHistory.totalSuccess,
		uploadPercentage: brochureAttachment.uploadProgress,
		errorCount: brochureAttachment.uploadHistory.totalErrors,
		allUploaded: brochureAttachment.uploadHistoryFiles.length === brochureAttachment.uploadHistory.totalFiles,
		previouslyUploadedCount: 0,
		deletedCount:0,
		allDeleted:false
	}

    return (
        <>
            <div className='brochure-listing'>
                <UploadFilesView
                    fileAttachmentArr={brochureAttachment.fileAttachments}
                    progressProps={progressProps}
                    uploadedCount={brochureAttachment.fileAttachments?.length}
                    uploadedFileModalData={uploadedFileModalData}
                    hideAddButton={true}
                    saveDisplayName={saveDisplayName}
                    validateInput={validateInput}
                    toggleEditDisplayNameModal={props.toggleEditDisplayNameModal}
                    imagePreviewRef={imagePreviewRef}
                    isBrochure={true}
                    brochureFileHistory={brochureAttachment.uploadHistoryFiles}
                    isContractor={isContractor}
                    isReadOnly={props.session.isReadOnly}
                >
                    <DisputeImages
                        list={brochureAttachment.fileAttachments}
                        maxSize={25}
                        maxFiles={1000}
                        isPurchaseImage={false}
                        swipeableDrawer={() => {
                            }}
                    ignoreMobilOption={true}
                    validTypes = {['jpg', 'jpeg', 'png', 'webp','pdf']}
                    brochureAttachment={OrderAttachments}
                    customBtn={{
                        btnTxt: "Upload File",
                        icon: (
                            <i className='icon-Folder brochure-folder' />
                        )
                    }}
                    updateUploading={() => {

                    }}
                    updateError={() => console.log('error')}
                    updateList={(list) => {
                        console.log(list)
                    }}
                    onDelete={onDelete}
                    onFileUpload={handleFileChange}
                    from='brochure'
                    isContractor={isContractor}
                />
                </UploadFilesView>
                <ImagePreview
                    key="preview"
                    isMobile={props.isMobile}
                    hashValue={props.isMobile?"imagePreview":""}
                    ref={imagePreviewRef}
                    imageList={previewImageList}
                    keepTextFixed={true}
                    textPlacement={'top'}
                    showHideCb = {action => bodyScrollHandler(action == 'show')}
                />
            </div>
            {showDeleteModal.show ?
                <DeleteModal
                    title={'Delete File'}
                    subTitle={"Are you sure you want to delete this file?"}
                    btnTxt={'Delete'}
                    onHidden={() => toggleDeleteModal({ show: false , data: null })}
                    onDelete={handleDelete}
                />
            : null}
            {brochureModalData.show &&
                <BrochureUploadModal
                    onHidden={() => setBrochureModalData({ show: false, files: [] })}
                    uploadedFiles={brochureModalData.files}
                    catalogLabel={props.session?.profileObject?.SingleLabelWithSpace}
                />
            }
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        isMobile: state.library.deviceData.isMobile,
        brochureAttachment: state.products.brochureAttachment,
        uploadedFileModalData: state.products.uploadedFileModalData,
        currentFile: state.products.fileAttachmentData.currentFile,
        session: state.session
    }
}

export default connect(mapStateToProps,{
    toggleEditDisplayNameModal,
    renameBrochureName,
    resetFileAttachmentData,
    deleteBrochure,
    resetBrochureFileHistory,
    toggleFileProgressBar
})(BrochureListing);